import { styled } from '@mui/material/styles'
import { Paper, Popper as MuiPopper } from '@mui/material'

export const StyledPopper = styled(MuiPopper)({
  zIndex: 1000,
  borderColor: '#F6F6F6',
  boxSizing: 'border-box',
  marginTop: '10px !important',
})

export const StyledPaper = styled(Paper)(({ width }) => ({
  position: 'relative',
  width: width ?? '500px',
  minWidth: width ?? '500px',
  maxWidth: 'none',
  borderRadius: '16px',
  border: '1px solid #EFEFEF',
  padding: '24px',
  boxSizing: 'border-box',
  boxShadow: `
    0px 1.85px 3.15px 0px #00000014,
    0px 8.15px 6.52px 0px #0000000A,
    0px 20px 13px 0px #0000000A,
    0px 38.52px 25.48px 0px #0000000B,
    0px 64.81px 46.85px 0px #0000000E,
    0px 100px 80px 0px #00000014
  `,
  minHeight: '50px',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-7px',
    left: '24px',
    width: '12px',
    height: '12px',
    backgroundColor: '#FFFFFF',
    borderLeft: '1px solid #EFEFEF',
    borderTop: '1px solid #EFEFEF',
    transform: 'rotate(45deg)',
    boxSizing: 'border-box'
  }
}))
